export default __webpack_public_path__ + "static/validatorexample-4e6353dc7d7624805fcfeda746ffc48c.png";